import { z } from "zod";

export const ThemeVariationValues = ["Primary", "Light", "Dark", "Gray", "Black"] as const;
export const ThemeVariationEnum = z.enum(ThemeVariationValues);
export type ThemeVariation = z.infer<typeof ThemeVariationEnum>;
